<app-header></app-header>
<app-curso-layout [curso]="curso"></app-curso-layout>
<app-footer></app-footer>